module.exports = "\r\n<router-outlet></router-outlet>\r\n<p-growl [(value)]=\"msgs\" life=\"1000000\" ></p-growl>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main